import axios, { AxiosResponse } from "axios";
import { CropsNetworkResponse, GetCropsParams } from "./schemas";
import { createGranularRequestConfig } from "@granular/fabric-catalog-helpers";
import { API, CROPS, V4, SERVICE } from "./constants/url";

const getCrops = async ({
  region = "us",
  domain = "",
  catalogConfig,
  axiosRequestConfig,
}: GetCropsParams): Promise<AxiosResponse<CropsNetworkResponse>> => {
  const response = await axios.get(
    `${domain}${API}${SERVICE}${V4}${CROPS}?admin_region=${region.toUpperCase()}`,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  getCrops,
};
